import { BOA_KEY, sUrls, VERSION } from "../../constants/ApiUrls";
import {
  deleteData,
  getData,
  postData,
  updateData,
} from "../../networkManager/NetworkManager";

export const getAllUsersS = async (id) => {
  return await getData(BOA_KEY + VERSION + `${id}/${sUrls.GET_ALL_USERS_S}`);
};

export const addUsersS = async (data) => {
  return await postData(BOA_KEY + VERSION + sUrls.SAVE_USERS_S, data);
};

export const removeUserS = async (key) => {
  return await deleteData(BOA_KEY + VERSION + sUrls.DELETE_S, key);
};

export const updateUserS = async (data, id) => {
  return await updateData(
    BOA_KEY + VERSION + `${id}/${sUrls.UPDATE_USER_S}`,
    data
  );
};
